// Sample data - in a real app this would come from props or API
import logoWithoutText from "../../components/assets/logo-without-text.svg";
import { questionareFields } from "./backendFieldsMappings/getVehicleDataMappings";

export const carData = {
  images: [
    "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
  ],
  vehicleInfo: {
    vin: "5UXTY5C00LL138420",
    location: "Brantford",
    year: "2020",
    make: "BMW",
    model: "X3",
    trim: "30i",
    transmission: "Automatic",
    odometer: "56,000",
    color: "Yellow",
    keys: "3",
    externalDamage: "Hail Damage,Dents",
    interiorDamage: "BLUETOOTH, HEATED STEERING WHEEL",
  },
  priceIndicators: [
    { label: "Low", value: 25105 },
    { label: "Average", value: 27704 },
    { label: "Awesome", value: 30304 },
  ],
  questions: [
    {
      question: "Do you smoke in this vehicle?",
      answer: "No",
      fieldName: questionareFields.Smoke_In_Vehicle,
    },
    {
      question: "Do you have original factory rims?",
      answer: "No",
      fieldName: questionareFields.Original_Factory_Rims,
    },
    {
      question: "Have you replaced your tires in last 12 month?",
      answer: "No",
      fieldName: questionareFields.Tires_Repld_12_Months,
    },
    {
      question: "Is your car drivable?",
      answer: "No",
      fieldName: questionareFields.Vehicle_Drivable,
    },
    {
      question: "Any crack on the windshield?",
      answer: "No",
      fieldName: questionareFields.Windshield_Crack,
    },
    {
      question: "Do you have any extended warranty?",
      answer: "No",
      fieldName: questionareFields.Extended_Warranty,
    },
    // { question: "Are you interested in a trade in?", answer: "No" },
    // { question: "Why are you selling?", answer: "No" },
    // { question: "Describe the condition of the car", answer: "Good" },
    // { question: "Any Accident Claims? How Much?", answer: "No" },
    // { question: "What Rims Are On The Car?", answer: "After Market" },
    // { question: "Do You Have Stock Rims?", answer: "No" },
    // { question: "Any Issues With The Vehicle?", answer: "No" },
    // { question: "Are There Any Modifications On The Car?", answer: "No" },
  ],
  bidHistory: [
    {
      bidderIcon: logoWithoutText,
      amount: 13000,
      dateTime: "2025-03-14 19:04:04",
    },
    {
      bidderIcon: logoWithoutText,
      amount: 13000,
      dateTime: "2025-03-14 19:04:04",
    },
    {
      bidderIcon: logoWithoutText,
      amount: 13000,
      dateTime: "2025-03-14 19:04:04",
    },
  ],
};

export const CAR_STATUSES = {
  approval_pending: "approval_pending",
  draft: "Draft",
  disapproved: "Disapproved",
  "list-to-auction": "list-to-auction",
  "listed-in-auction": "listed-in-auction", 
  "live-in-auction": "live-in-auction", 
  "listed-to-auction": "listed-to-auction", 
  "in-negotiation": "in-negotiation", 
   "relist-pending": "relist-pending",
  "sold-car": "sold-car",
  "unsold-car": "unsold-car",
  "cancelled": "cancelled",
};

export const CAR_STATUS = {
  APPROVAL_PENDING: "approval_pending",
  DRAFT: "draft",
  DISAPPROVED: "Disapproved",
  LIVE_IN_AUCTION: "live-in-auction",
  LISTED_TO_AUCTION: "listed-in-auction",
  BUY_NOW: "Buy Now",
  LIST_TO_AUCTION: "List To Auction",
  IN_NEGOTIATION: "In negotiation",
  // UNSOLD_CAR: "Unsold Car",
  UNSOLD_CAR: "unsold-car",
  SOLD_CAR: "sold-car",
  RELIST_PENDING: "relist-pending",
  LIST_TO_AUCTION: "list-to-auction",
  CANCELLED: "cancelled"
};

export const ORDER_PAYMENT_STATUS = {
  PENDING: "Pending",
  SUCCESS: "success",
  SUCCESSFUL: "successful",
  FAILED: "failed"
};

export const CAR_STATUS_LABELS = {
  approval_pending: "Approval Pending",
  "live-in-auction": "Live in auction",
  "listed-in-auction": "Listed in auction",
  "listed-to-auction": "Listed to auction",
  "draft": "Draft",
  "sold-car": "Sold car",
  "list-to-auction": "List to auction",
  "cancelled": "Cancelled",
  Disapproved: "Disapproved",
  BUY_NOW: "Buy Now",
  "relist-pending": "Relist pending",
  LIST_TO_AUCTION: "List To Auction",
  "in-negotiation": "In negotiation",
  UNSOLD_CAR: "Unsold Car",
  "unsold-car": "Unsold car",
  SOLD_CAR: "Sold Car",
  DRAFT: "Draft",
  
};

export const carFieldsMapping = {
  Check_driving_condition: "Check driving condition",
  Mileage_Unit: "Mileage unit",
  Carfax_Report_Url: "Carfax report url",
  InteriorDamage: "Interior damage",
  ExteriorDamage: "Exterior damage",
  Relist_Count: "Relist count"
};

const preferredCarBrands = [
  "Toyota",
  "Honda",
  "Ford",
  "Chevrolet",
  "BMW",
  "Mercedes-Benz",
  "Audi",
  "Volkswagen",
  "Nissan",
  "Hyundai",
  "Kia",
  "Mazda",
  "Subaru",
  "Tesla",
  "Lexus",
  "Acura",
  "Infiniti",
  "Other"
];

const paymentStatusMapping = {
  "successful": true,
  "Pending": false,
};

const imageCategories = {
  interior: "interior",
  exterior: "exterior",
  dashboard: "damage",
  rims: "rims"
};

const imageFieldToImageCategoriesMap = {
  Interior_Image: imageCategories.Interior,
  Interior_Image2: imageCategories.Interior,
  Interior_Image3: imageCategories.Interior,
  Interior_Image4: imageCategories.Interior,
  Exterior_Image: imageCategories.Exterior,
  Exterior_Image2: imageCategories.Exterior,
  Exterior_Image3: imageCategories.Exterior,
  Exterior_Image4: imageCategories.Exterior,
  Rims_Image: imageCategories.Rims,
  Rims_Image2: imageCategories.Rims,
  Rims_Image3: imageCategories.Rims,
  Rims_Image4: imageCategories.Rims,
};

export {
  preferredCarBrands,
  paymentStatusMapping,
  imageFieldToImageCategoriesMap,
  imageCategories
}